<template>
  <div>
    <h3>編集</h3>
    <div class="p-p-3">
      <InputText v-model="videoUrl" placeholder="動画URL" /><Button
        label="動画選択"
        @click="changeVideo"
      />
    </div>
    <SongEditorPart ref="sep" @play="play" @exportParam="test" />
    <div class="cards">
      <PreSongCard
        @remove="removeSong"
        v-for="song in reverseSongs"
        :key="song"
        :screenTitle="song.screenTitle"
        :start="song.start"
        :end="song.end"
        :tags="song.tags"
        :videoId="videoId"
        :index="song.index"
      />
    </div>
    <Button @click="save" class="saveButton" label="保存" />
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import SongEditorPart from "@/components/SongEditorPart.vue";
import PreSongCard from "@/components/PreSongCard.vue";
import InputText from "primevue/inputtext";
import Button from "primevue/button";

export default defineComponent({
  name: "SongEditor",
  components: { SongEditorPart, PreSongCard, InputText, Button },
  setup() {
    return { videoUrl: ref(""), songs: ref([]) };
  },
  methods: {
    play(start) {
      console.log("songeditor", "play");
      this.$emit("play", start);
    },
    test(e) {
      const date = new Date();
      const tmp = {
        screenTitle: e.title,
        start: e.start,
        end: e.end,
        tags: e.tags,
        videoId: this.videoId,
        index: date.getTime(),
      };
      this.songs.push(tmp);
      this.$emit("exportParam", e);
    },
    changeVideo() {
      this.$emit("changeVideo", this.videoId);
    },
    removeSong(index) {
      console.log(index);
      this.songs = this.songs.filter((song) => song.index != index);
    },
    save() {
      this.$emit("save", this.songs);
    },
    setTagsFilter() {
      console.log("songeditor settagfilter");
      this.$refs.sep.setTagsFilter();
    },
    reload() {
      console.log('reload in SongEditor')
      this.songs.splice(0);
    },
  },
  computed: {
    videoId() {
      const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = this.videoUrl.match(regExp);
      return match && match[7].length == 11 ? match[7] : "false";
    },
    reverseSongs() {
      return this.songs.slice().reverse();
    },
  },
});
</script>

<style scoped>
.saveButton {
  position: fixed;
  bottom: 20px;
  right: 25%;
  margin-right: 20px;
}
.cards {
  margin-top: 20px;
  overflow: auto;
  height: calc(400px);
  border: solid 2px gray;
}
</style>
